<tablesready-tr-table
  [rows]="parties"
  [columns]="columns"
  [columnsToSave]="columnsToSave"
  [columnHints]="columnHints"
  stateId="waitlist"
  [locationId]="location?._id"
  dataKey="_id"
  [trackBy]="trackById"
  [sortBy]="sortBy"
  [sortAscending]="!sortReverse"
  [scrollHeight]="scrollHeight"
  [hasMore]="hasMore"
  [displayCompact]="displayCompact"
  [resizableColumns]="resizableColumns"
  [rowId]="rowId"
  [rowHidden]="rowHidden"
  [highlightedId]="highlightedPartyId"
  [emptyMessage]="'No waiting ' + (location?.displayOptions?.labels?.customer_plural || 'parties') + '.'"
  (orderByChange)="onOrderBy($event)"
  (columnsUpdated)="updateColumns($event)"
  (loadMore)="loadMore.emit()"
>
  <ng-template trCell="pos" let-i="index">{{ i + 1 }}</ng-template>

  <ng-template trCell="name" let-party let-i="index" let-visibleKeys="visibleKeys">
    <div class="d-flex flex-column justify-content-center align-items-start">
      <div class="d-flex flex-row justify-content-start align-items-baseline">
        <span class="lead name name-edit" data-dd-privacy="mask" role="button"
              (click)="actionsCallbacks?.addEditParty(party)" id="edit-party-{{i}}">{{party?.name}}</span>&nbsp;
        <tablesready-party-badge
          [party]="party"
          [showTypeBadge]="party.type === partyTypes.reservation || party.type === partyTypes.togo"
        ></tablesready-party-badge>
        <shared-badge *ngIf="unpaid(party)" [label]="'Unpaid'" [class]="'badge badge-pill badge-danger'"></shared-badge>
        <shared-badge *ngIf="paid(party)" [label]="'Paid'" [class]="'badge badge-pill badge-success'"></shared-badge>
      </div>

      <div class="d-flex flex-column align-items-start">
        <span *ngIf="unpaid(party)" class="d-flex flex-row font-weight-bold">
          <span class="pr-1">Holding for:</span>
          <tablesready-countdoun-timer [milliseconds]="getRemainingSecondsToPay(party.created_time)"></tablesready-countdoun-timer>
        </span>
        <span *ngIf="paid(party) && party.stripeData?.paymentLink">
          <a class="text-link" [href]="party.stripeData?.paymentLink" target="_blank">Manage Payment</a>
        </span>
        <span class="secondary tr-subline">
          <span *ngIf="party?.loyalty_count >= 1" class="tr-visits">{{party?.loyalty_count}} {{ party?.loyalty_count === 1 ? 'visit' : 'visits' }}<span *ngIf="party?.phone" class="tr-sep">·</span></span>
          <span *ngIf="party?.phone" class="tr-phone" data-dd-privacy="mask">{{ party?.phone | trTel:location?.country:'custom' }}</span>
        </span>
        <!--
          The note lives under the name only while the Notes column is hidden —
          which is now a per-device choice in the show/hide columns modal, not the
          location's `waitFields.note_column` (that flag is only its default).
        -->
        <span *ngIf="party?.note && !visibleKeys?.has('note')">
          <span
            *ngIf="party?.source === partySources.square
              && location?.integrations?.squareOptions?.showOrderItems
              && isArray(party?.note)"
          >
            <ul class="list-unstyled mb-1">
              <li *ngFor="let item of party.note">{{item}}</li>
            </ul>
          </span>
          <span
            *ngIf="!(party?.source === partySources.square
              && location?.integrations?.squareOptions?.showOrderItems
              && isArray(party?.note))"
          >{{ isArray(party?.note) ? party?.note.join(', ') : party?.note}}</span>
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template trCell="size" let-party>{{party?.size}}</ng-template>

  <ng-template trCell="note" let-party>
    <span
      *ngIf="party?.source === partySources.square
        && location?.integrations?.squareOptions?.showOrderItems
        && isArray(party?.note)"
    >
      <ul class="list-unstyled mb-1">
        <li *ngFor="let item of party.note">{{item}}</li>
      </ul>
    </span>
    <!--
      Notes clamp to two lines and offer the full text in a click-popover, so one long note
      can't stretch every row. The popover disables itself when nothing is cut off, and a
      click trigger (not hover) works on touch/iOS.
    -->
    <span #noteTxt
      *ngIf="!(party?.type === partyTypes.order
        && party.source === partySources.square
        && location?.integrations?.squareOptions?.showOrderItems
        && isArray(party?.note))"
      class="clamp-2"
      [attr.role]="noteTxt.scrollHeight > noteTxt.clientHeight ? 'button' : null"
      [ngbPopover]="isArray(party?.note) ? party?.note.join(', ') : party?.note"
      [disablePopover]="noteTxt.scrollHeight <= noteTxt.clientHeight"
      triggers="click"
      container="body" placement="bottom-left bottom-right top-left top-right bottom top"
    >{{ isArray(party?.note) ? party?.note.join(', ') : party?.note}}</span>
  </ng-template>

  <ng-template trCell="service" let-party>
    <tablesready-model-name-display class="clamp-2" [id]="party?.services" [models]="services"></tablesready-model-name-display>
  </ng-template>

  <ng-template trCell="resource" let-party>
    <tablesready-model-name-display class="clamp-2" [id]="party?.resources" [models]="resources"></tablesready-model-name-display>
  </ng-template>

  <ng-template trCell="quoted" let-party>
    <tablesready-waitlist-quoted-time
      [party]="party"
      [label]="location?.displayOptions?.labels?.quoted"
      [timezone]="location.timezone"
      [showMobileLabel]="false"
    ></tablesready-waitlist-quoted-time>
  </ng-template>

  <ng-template trCell="arrival" let-party>
    <ng-container *ngIf="party?.checkin_time">{{party?.checkin_time | trDateFormat:'h:mm a':location.timezone}}</ng-container>
    <ng-container *ngIf="!party?.checkin_time">Not checked in</ng-container>
  </ng-template>

  <ng-template trCell="wait" let-party>
    {{ (party?.checkin_time ? (now - party?.checkin_time) : 0) | trTimeDelta}}
  </ng-template>

  <ng-template trCell="custom" let-party let-col="column">
    <ng-container *ngIf="displayCustomFieldCell(party, col.customFieldId)">
      <!-- free-text fields can be long: same two-line clamp + popover as notes -->
      <span #cfTxt
        *ngIf="!col.customFieldTel && col.customFieldText"
        data-dd-privacy="mask"
        class="clamp-2"
        [attr.role]="cfTxt.scrollHeight > cfTxt.clientHeight ? 'button' : null"
        [ngbPopover]="party.customFields[col.customFieldId]"
        [disablePopover]="cfTxt.scrollHeight <= cfTxt.clientHeight"
        triggers="click"
        container="body" placement="bottom-left bottom-right top-left top-right bottom top"
        [innerHTML]="party.customFields[col.customFieldId]"
      ></span>
      <span
        *ngIf="!col.customFieldTel && !col.customFieldText"
        data-dd-privacy="mask"
        [innerHTML]="party.customFields[col.customFieldId]"
      ></span>
      <span
        *ngIf="col.customFieldTel"
        data-dd-privacy="mask"
        [innerText]="party.customFields[col.customFieldId] ? (party.customFields[col.customFieldId] | trTel:location.country:'custom') : ''"
      ></span>
    </ng-container>
  </ng-template>

  <ng-template trCell="messages" let-party let-i="index" let-listMode="listMode">
    <tablesready-waitlist-messages
      [party]="party"
      [index]="i"
      [timezone]="user.location.timezone"
      [notificationTime]="user.location.displayOptions.notificationTime"
      [messagesActions]="messagesActions"
      [listLayout]="!!listMode"
    ></tablesready-waitlist-messages>
  </ng-template>

  <ng-template trCell="actions" let-party let-i="index" let-listMode="listMode">
    <tablesready-waitlist-actions
      [party]="party"
      [index]="i"
      [user]="user"
      [callbacks]="actionsCallbacks"
      [notifyActions]="notifyActions"
      [voicePageNotificationEnabled]="user.location.messages.voicePageNotification.enabled"
      [timezone]="user.location.timezone"
      [isMobile]="isHandset"
      [anyPartyNotifiable]="anyPartyNotifiable"
      [listLayout]="!!listMode"
    ></tablesready-waitlist-actions>
  </ng-template>
</tablesready-tr-table>
